import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import Introduction from "@/components/introduction.vue";
import AboutMe from "@/components/about-me.vue";
import Experience from "@/components/experience.vue";
import Works from "@/components/works.vue";
import Contact from "@/components/contact.vue";
import Footer from "@/components/footer.vue";
import {onMounted, ref} from "vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


const animateSections = ref([false, false, false, false, false]);
const sectionRefs1 = ref(null);
const sectionRefs2 = ref(null);
const sectionRefs3 = ref(null);
const sectionRefs4 = ref(null);
const sectionRefs5 = ref(null);
const sectionRefs = ref([null, null, null, null, null]);

function handleScroll() {
    const viewportHeight = window.innerHeight;
    sectionRefs
    sectionRefs1
    const sectionRect1 = sectionRefs1.value.getBoundingClientRect();

    if (sectionRect1.top < viewportHeight && sectionRect1.bottom >= 0) {
        animateSections.value[0] = true;
    }

    const sectionRect2 = sectionRefs2.value.getBoundingClientRect();

    if (sectionRect2.top < viewportHeight && sectionRect2.bottom >= 0) {
        animateSections.value[0] = true;
    }

    const sectionRect3 = sectionRefs3.value.getBoundingClientRect();

    if (sectionRect3.top < viewportHeight && sectionRect3.bottom >= 0) {
        animateSections.value[0] = true;
    }

    const sectionRect4 = sectionRefs4.value.getBoundingClientRect();

    if (sectionRect4.top < viewportHeight && sectionRect4.bottom >= 0) {
        animateSections.value[0] = true;
    }

    const sectionRect5 = sectionRefs5.value.getBoundingClientRect();

    if (sectionRect5.top < viewportHeight && sectionRect5.bottom >= 0) {
        animateSections.value[0] = true;
    }

    // sectionRefs.value.forEach((section, index) => {
    //     const sectionRect = section.getBoundingClientRect();
    //
    //     if (sectionRect.top < viewportHeight && sectionRect.bottom >= 0) {
    //         animateSections.value[index] = true;
    //     }
    // });
}

onMounted(() => {

    window.addEventListener('scroll', handleScroll);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (animateSections.value[0]||true)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "sectionRefs1",
              ref: sectionRefs1
            }, [
              _createVNode(Introduction)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (animateSections.value[1]||true)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "sectionRefs2",
              ref: sectionRefs2
            }, [
              _createVNode(AboutMe)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (animateSections.value[2] ||true)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "sectionRefs3",
              ref: sectionRefs3
            }, [
              _createVNode(Experience)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (animateSections.value[3] ||true)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "sectionRefs4",
              ref: sectionRefs4
            }, [
              _createVNode(Works)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (animateSections.value[4]||true)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              ref_key: "sectionRefs5",
              ref: sectionRefs5
            }, [
              _createVNode(Contact)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})